import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import Login from "./Login";

import CorePage from 'src/Forms/core/CorePage'
import DialogScalePage from 'src/Forms/dialog/DialogScalePage1';
import RcadsPage1 from 'src/Forms/rcads/RcadsPage1';
import RcadsAdultPage1 from "src/Forms/rcadsAdult/RcadsAdultPage1";
import ReqolPage from "src/Forms/reqol/ReqolPage";
import SavedPage from 'src/Forms/SavedPage';
import SdqFormPage1 from 'src/Forms/sdq/SdqFormPage1';
import SdqFormPage2 from 'src/Forms/sdq/SdqFormPage2';
import SdqFormPage3 from 'src/Forms/sdq/SdqFormPage3';

import ContentWrapper from 'src/SharedComponents/ContentWrapper';
import { SessionContext, SessionContextProvider } from 'src/Views/SessionContext';

const PageIndex = () => <SessionContextProvider>
    <RoutedIndex />
</SessionContextProvider>;

interface IRouteProps {
    token: string
};

const IndexWithSession = (routeComponentProps: RouteComponentProps<IRouteProps>) => {
    const sessionContext = React.useContext(SessionContext);
    const { page, webToken } = sessionContext.state;
    const { match } = routeComponentProps;
    const token = match.params.token;

    if (page && webToken) {
        const pageId = page.formId + "" + page.page;
        switch (pageId) {
            case "11":
                return <SdqFormPage1 />
            case "12":
                return <SdqFormPage2 />
            case "13":
                return <SdqFormPage3 />
            case "21":
                return <RcadsPage1 token={token} />
            case "22":
            case "313":
            case "412":
                return <SavedPage />
            case "61":
                return <CorePage token={token} />
            case "40":
            case "41":
            case "42":
            case "43":
            case "44":
            case "45":
            case "46":
            case "47":
            case "48":
            case "49":
            case "410":
            case "411":
                return <DialogScalePage token={token} />
            case "31":
            case "32":
            case "33":
            case "34":
            case "35":
            case "36":
            case "37":
            case "38":
            case "39":
            case "310":
            case "311":
            case "312":
                return <ReqolPage token={token} />
            case "51":
                return <RcadsAdultPage1 token={token} />
        }
    }

    return <ContentWrapper>
        <Login token={token} />
    </ContentWrapper>;
};

const RoutedIndex = withRouter(IndexWithSession);

export default PageIndex;



// WEBPACK FOOTER //
// ./src/Views/ViewsIndex.tsx